import styled from 'styled-components';
import { palette } from 'styled-tools';

export const TitleWrapper = styled.div`
  text-align: center;
`;
export const CheckBoxWrapper = styled.div`
  display: flex;
  &:not(:first-child) {
    > div:last-child {
      border-top: 1px solid ${palette('gray_opacity_100')};
    }
  }
`;

export const RadioWrapper = styled.div`
  position: relative;
  padding: 14px 0;
`;

export const CheckLabelWrapper = styled.div`
  width: 100%;
  padding: 14px 0;
  margin-left: 12px;
`;

interface GridWrapperProps {
  isLast: boolean;
}
export const GridWrapper = styled.div<GridWrapperProps>`
  width: ${(props) => (props.isLast ? '100' : '49')}%;
  &:not(:first-child) {
    margin-bottom: 4px;
  }
`;
